import React from 'react';

export const FlagGray600Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_8661_46085)">
        <path
          d="M17.6 10.59L14.96 7.32999L17.6 4.06999C18.06 3.49999 18.15 2.72999 17.84 2.06999C17.53 1.40999 16.87 0.98999 16.13 0.98999H3.77C2.73 0.98999 1.88 1.83999 1.88 2.87999V17.99C1.88 18.54 2.33 18.99 2.88001 18.99C3.43001 18.99 3.88 18.54 3.88 17.99V13.66H16.13C16.87 13.66 17.52 13.25 17.84 12.58C18.16 11.92 18.07 11.15 17.6 10.58V10.59ZM3.88 11.67V2.99999H15.89L12.89 6.69999C12.59 7.06999 12.59 7.58999 12.89 7.95999L15.89 11.66H3.88V11.67Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_8661_46085">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
